// @flow

import React from 'react';

import styles from './denominationReciept.scss';
import InputField from '../../commons/formElements/inputField/inputField';
import { strUsables } from '../../../services/helpers';

type Props = {
  passDenominationDetailsToParent: Function,
  isGrandTotalValid?: boolean,
  noPadding?: boolean
};

type State = {
  grandTotal: number,
  denominationsCount: Object
};

class DenominationReciept extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = {
      grandTotal: 0,
      denominationsCount: {}
    };
    this.denominations = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1];
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  calculateGrandTotalAndDenomination(count, denomination) {
    const [denominationsCount] = [this.state.denominationsCount];
    let [grandTotal] = this.state.grandTotal ? [this.state.grandTotal] : [0];
    denominationsCount[denomination] = denominationsCount[denomination]
      ? denominationsCount[denomination]
      : 0;
    grandTotal =
      grandTotal -
      denomination * denominationsCount[denomination] +
      denomination * count;

    denominationsCount[denomination] = count;

    return [grandTotal, denominationsCount];
  }

  handleInputChange(e, denomination) {
    const [
      grandTotal,
      denominationsCount
    ] = this.calculateGrandTotalAndDenomination(
      Number(e.target.value),
      denomination
    );
    this.setState(
      {
        grandTotal,
        denominationsCount
      },
      () => {
        this.props.passDenominationDetailsToParent(
          grandTotal,
          denominationsCount
        );
      }
    );
  }

  renderDenominations(denomination) {
    const denominationsCount = this.state.denominationsCount;
    return (
      <div
        className={`${styles.denominationInput} l-row a-end ${
          this.props.noPadding ? styles.noPadding : ''
        }
    `}
        key={denomination}
      >
        <div className="flex-40 l-row j-start">
          <span className="flex-50 j-start">{denomination}</span>{' '}
          <span className="flex-50 j-end"> X </span>
        </div>
        <div className="flex-30 j-start">
          <InputField
            type="number"
            onInput={e => this.handleInputChange(e, denomination)}
            inputClassName={styles.valuesInput}
            onChange={() => {}}
            minValue={0}
          />
        </div>
        <div className="flex-30 j-start">
          = {denomination * (denominationsCount[denomination] || 0)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className={`${styles.denominationWrapper} flex-100 l-col j-space-bet`}
      >
        <div>
          <div className={`${styles.header} l-row j-center`}>Denominations</div>
        </div>
        <div className={styles.content}>
          {this.denominations.map(denomination =>
            this.renderDenominations(denomination)
          )}
        </div>

        <div className={`${styles.footer} l-row a-center`}>
          <div className="flex-100 l-col">
            <div className="l-row">
              <div className="flex-50 l-row j-start">
                <div>
                  <span>Grand Total </span>
                </div>
              </div>
              <div className="flex-50 j-start">
                <span>
                  {`${strUsables.indianCurrencySymol} ${this.state.grandTotal}`}
                </span>
              </div>
            </div>
            {this.props.isGrandTotalValid === false ? (
              <div className="l-row j-center a-center">
                <span className={styles.errorMessage}>
                  Grand Total does not match with Collection amount!
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

DenominationReciept.defaultProps = {
  isGrandTotalValid: true
};

export default DenominationReciept;
